var _rect, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArpu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arpu",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1443",
    "data-name": "Rectangle 1443",
    width: 38,
    height: 38,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Player",
    transform: "translate(25.983 0.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_808",
    "data-name": "Group 808",
    transform: "translate(0.447 7.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4400",
    "data-name": "Path 4400",
    d: "M40.823,262.024H30.3c0-3.651,2.831-4.456,5.261-4.456S40.823,258.373,40.823,262.024Z",
    transform: "translate(-30.302 -257.568)",
    fill: "#65b0f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_809",
    "data-name": "Group 809",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4401",
    "data-name": "Path 4401",
    d: "M25.6,247.244H15.076a.439.439,0,0,1-.447-.447c0-3.159,2.027-4.9,5.708-4.9s5.708,1.744,5.708,4.9A.439.439,0,0,1,25.6,247.244Zm-10.059-.894h9.6c-.179-2.37-1.788-3.562-4.8-3.562S15.717,243.98,15.538,246.35Z",
    transform: "translate(-14.629 -234.994)",
    fill: "#3c4043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4402",
    "data-name": "Path 4402",
    d: "M113.726,6.244a3.1,3.1,0,0,1-2.966-3.219,2.966,2.966,0,1,1,5.931,0A3.1,3.1,0,0,1,113.726,6.244Zm0-5.35a2.028,2.028,0,0,0-2.071,2.131,2.085,2.085,0,1,0,4.143,0A2.054,2.054,0,0,0,113.726.894Z",
    transform: "translate(-108.018)",
    fill: "#3c4043"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "X",
    transform: "translate(5.564 3.883) rotate(30)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y2: 2.895,
    transform: "matrix(0.545, 0.839, -0.839, 0.545, 2.428, 0.425)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 2.895,
    transform: "matrix(0.545, 0.839, -0.839, 0.545, 0.426, 0)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    transform: "translate(14.302 5.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4383",
    "data-name": "Path 4383",
    d: "M168.041,54.1a1.185,1.185,0,1,1-1.185-1.185A1.185,1.185,0,0,1,168.041,54.1Z",
    transform: "translate(-165.671 -52.912)",
    fill: "#fee96b"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Circle-2",
    "data-name": "Circle",
    transform: "translate(1.382 10.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4385",
    "data-name": "Path 4385",
    d: "M168.041,54.1a1.185,1.185,0,1,1-1.185-1.185A1.185,1.185,0,0,1,168.041,54.1Z",
    transform: "translate(-165.671 -52.912)",
    fill: "#abda7c"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Balance",
    transform: "translate(2.071 9.862)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 12.022,
    cy: 12.022,
    rx: 12.022,
    ry: 12.022,
    fill: "none",
    stroke: "#3c4043",
    strokeMiterlimit: 2.613,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4386",
    "data-name": "Path 4386",
    d: "M177.984,84.05a9.822,9.822,0,1,1-9.821-9.821A9.821,9.821,0,0,1,177.984,84.05Z",
    transform: "translate(-156.161 -72.048)",
    fill: "#abd67c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_812",
    "data-name": "Group 812",
    transform: "translate(7.959 3.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M169.927,77.419c-2.408-1.661-6.232-.727-6.232,2.709,0,4.195,6.474,2.93,6.474,6.93,0,4.085-4.76,5.067-6.916,2.219",
    transform: "translate(-163.254 -74.945)",
    fill: "none",
    stroke: "#3c4043",
    strokeMiterlimit: 2.613,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    y2: 17.836,
    transform: "translate(3.398)",
    fill: "none",
    stroke: "#3c4043",
    strokeMiterlimit: 2.613,
    strokeWidth: 1.5
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_815",
    "data-name": "Group 815",
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 18.352, 25.513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_825",
    "data-name": "Group 825",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4450",
    "data-name": "Path 4450",
    d: "M13.8,2.187,12.777.142a.256.256,0,0,0-.343-.115h0L10.389,1.05a.256.256,0,1,0,.229.458L12.1.767l-.4,1.154A13.642,13.642,0,0,1,0,10.993l.043.511A14.154,14.154,0,0,0,12.177,2.09L12.59.911l.752,1.5a.256.256,0,0,0,.458-.229Z",
    transform: "translate(0 0.724) rotate(-3)",
    fill: "#3c4043",
    stroke: "#3c4043",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArpu);
export default __webpack_public_path__ + "static/media/arpu.1943c1dafe6cde9b9c3c0bd6a8feec56.svg";
export { ForwardRef as ReactComponent };